<template>
  <div class="card">
    <div class="card-body pb-1">
      <div class="row">
        <div class="col-sm-2 col-7">
          <box-info-connection :value="connectionSensor" :no-signal-date="noSignalDate" />
        </div>
        <div class="col-8 text-center d-none d-sm-block">
          <span class="h3">{{ name }}</span>
          <span id="deviceId" class="text-muted pl-3">{{ lastCharsGuid }}</span>
          <b-tooltip placement="bottom" custom-class="info-tooltip" target="deviceId">
            {{ $t('box.serialNumber') }}
            <br />
            {{ deviceIdInternal }}
          </b-tooltip>
        </div>
        <div class="col-sm-2 col-5 text-right">
          <box-info-battery :value="batteryValue" :charging="batterCharging" />
        </div>
        <div class="col-12 text-center d-sm-none pb-2">
          <span class="h3">{{ name }}</span>
          <span id="deviceId" class="text-muted ml-3">{{ lastCharsGuid }}</span>
        </div>
        <div class="col-lg-6">
          <box-info-photo
            :device-id="deviceIdInternal"
            :image-url="imageUrl"
            :modelCodeBox="modelCodeBox"
          ></box-info-photo>
        </div>
        <div v-if="item" class="col-lg-6">
          <div>
            <div v-if="nominalPower" class="col">
              <div class="card aligner-wrapper">
                <div class="card-body">
                  <div class="absolute left top bottom h-60 v-strock-2 bg-warning"></div>
                  <p class="text-muted mb-2">{{ $t('box.nominalPower') }}</p>
                  <div class="d-xl-flex align-items-center">
                    <h1 class="font-weight-medium mb-2">
                      {{ nominalPower + ' ' + kvt }}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="targetEfficiency" class="col">
              <div class="card aligner-wrapper">
                <div class="card-body">
                  <div class="absolute left top bottom h-100 v-strock-2 bg-success"></div>
                  <p class="text-muted mb-2">
                    {{ $t('box.targetEfficiency') }}
                  </p>
                  <div class="d-xl-flex align-items-center">
                    <h1 class="font-weight-medium mb-2">
                      {{ targetEfficiency + ' %' }}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <b-button
            v-if="dashboardUrl"
            variant="primary btn-block"
            class="btn-icon-text mb-3"
            @click="onDashboard"
          >
            <h3>
              <span class="mdi mdi-access-point-network btn-icon-prepend"></span>
              {{ $t('boxInfo.onLineDataLink.label') }}
            </h3>
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { convertToShortGuid } from '@/utils/utils.js';

export default {
  name: 'BoxInfoMain',
  props: {
    item: Object,
  },
  data() {
    return {
      dashboardModal: false,
      lastCharsGuid: '',
    };
  },
  computed: {
    name() {
      return ((this.item || {}).digitalThing || {}).name || '';
    },
    typeName() {
      return this.item && this.item.boxEquipmentType == '0'
        ? this.$t('boxEquipmentType.types.continuous')
        : this.$t('boxEquipmentType.types.discrete');
    },
    nominalPower() {
      return this.item && this.item.nominalPower;
    },
    targetEfficiency() {
      return (
        ((((this.item || {}).digitalThing || {}).workCenter || {}).efficiencyParam || {})
          .targetEfficiency || 85
      );
    },
    connectionSensor() {
      return (((this.item || {}).mobileNetworkSensor || {}).lastValue || {}).value || 0;
    },
    currentOperationMode() {
      return (
        ((((this.item || {}).digitalThing || {}).workCenter || {}).operationModeSensor || {})
          .lastValue || {}
      );
    },
    noSignalDate() {
      return this.currentOperationMode.value === 0 ? this.currentOperationMode.timeStamp : null;
    },
    batterCharging() {
      return (((this.item || {}).chargeModeSensor || {}).lastValue || {}).value || 0;
    },
    batteryValue() {
      return (((this.item || {}).batterySensor || {}).lastValue || {}).value || -1;
    },
    imageUrl() {
      return (
        ((((this.item || {}).digitalThing || {}).workCenter || {}).attachmentImage || {}).url || ''
      );
    },
    modelCodeBox() {
      return this.item.modelCode;
    },
    dashboardUrl() {
      return (((this.item || {}).digitalThing || {}).uiPage || {}).url || null;
    },
    loading() {
      return this.$store.getters['eam/loading'];
    },
    deviceIdInternal() {
      return this.deviceId || this.$route.params.deviceId;
    },
    kvt() {
      return this.$t('dashboards.kvt');
    },
  },
  watch: {
    $route(to) {
      if (!to.hash) {
        this.dashboardModal = false;
      }
    },
  },
  mounted() {
    if (this.batteryValue < 21 && this.batteryValue != -1) {
      this.makeToast();
    }
    this.lastCharsGuid = convertToShortGuid(this.deviceIdInternal);
  },
  methods: {
    makeToast() {
      this.$bvToast.toast(this.$t('box.battery.batteryCharge'), {
        title: this.$t('box.battery.attention'),
        variant: 'danger',
        noAutoHide: true,
        solid: true,
      });
    },
    onDashboard() {
      this.$router.push({
        name: 'boxiiot',
        params: {
          deviceId: this.item.deviceId,
        },
      });
    },
  },
};
</script>

<style>
.dashboard-modal {
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 100%;
  margin: 0;
  padding: 0 !important;
}
</style>
